export default "__VITE_ASSET__BdGLbIrK__"